export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const DISMISS_MESSAGE = "DISMISS_MESSAGE";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const USER_DATA_UPDATE = "USER_DATA_UPDATE";
export const SET_IS_PBS_AUTHORITY_REQUIRED = "SET_IS_PBS_AUTHORITY_REQUIRED";
export const SET_IS_RE_AUTHENTICATION_REQUIRED =
    "SET_IS_RE_AUTHENTICATION_REQUIRED";
export const SET_PRESCRIBING_MESSAGE = "SET_PRESCRIBING_MESSAGE"; // just copied prescription form from PMS
export const UPDATE_EBS_NUMBER = "UPDATE_EBS_NUMBER"; // ebs number for prescription

export const SAVE_ATTACHMENT = "SAVE_ATTACHMENT"; // attachments for the instant swtich prescription
export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";

export const SAVE_DRUG_INFO = "SAVE_DRUG_INFO";
export const DELETE_DRUG_INFO = "DELETE_DRUG_INFO";
export const REMOVE_ASSESSMENT_DATA = "REMOVE_ASSESSMENT_DATA";

export const UPDATE_MIMS_EULA_REVISION = "UPDATE_MIMS_EULA_REVISION";
export const UPDATE_MIMS_TERMS_REVISION = "UPDATE_MIMS_TERMS_REVISION";
